
import { defineComponent } from 'vue';
import DiscoverContent from './discoverContent.vue';
import { getMetaInfo, header, extractTitleFromMetaInfo, getDefaultTitle, getLdJson } from '@/common/seo';
import { setCommonParamsCookiesInServer } from '@/common/common-params';
import { DiscoverApi } from '~/api/discover';
import { RequestSource, ResponseBaseResult, WebFeedType } from '~/api/base';
import { Feed } from '~/api/feed';

const ForbidWordRegExp =
    /[\u4e00-\u9fa5]|(https?:\/\/.*)|(\.(com|net|org|co|io|gov|edu|biz|info|me|mil|tv|name|cc|app|dev|cloud|shop|site|tech|online|pro|win|cn))/i;

export default defineComponent<any>({
    async asyncData(ctx) {
        let seoData = [];
        let metaInfoData = [];
        let title = getDefaultTitle(ctx);
        const pidStrList = [];
        let feedsListOrigin: Array<Feed> = [];
        let cursor: number | string = 0;

        if (process.server) {
            try {
                const isForbidWord = ForbidWordRegExp.test(ctx.route.params.content || '');

                if (isForbidWord) {
                    ctx.redirect(301, '/foryou');
                    return;
                }

                setCommonParamsCookiesInServer({
                    bucket: ctx.store.state.startup.bucket,
                    host: ctx.req.headers.host,
                    ctx,
                    countryInfo: ctx.store.state.startup.countryInfo,
                });

                const content = ctx?.route?.params?.content || '';
                const response = await DiscoverApi(ctx?.$axios).getDiscoverList({
                    searchWord: encodeURIComponent(content?.trim()?.replace(/\s/g, '-')),
                    pcursor: 0,
                    count: 8,
                    fromUser: false,
                    mobile: true,
                    request_source: RequestSource.REQUEST_SOURCE_PWA_SEO_DISCOVER,
                });
                if (response?.result === ResponseBaseResult.RESULT_OK) {
                    feedsListOrigin = response?.feeds || [];
                    cursor = response?.pcursor || '';

                    if (response?.feeds?.length) {
                        for (let i = 0; i < response?.feeds?.length; i++) {
                            pidStrList.push(response.feeds?.[i]?.photo_id_str || '');
                        }
                    }
                }

                // 处理metaInfo和结构化数据
                const url = `https://${ctx?.req?.headers?.host}${ctx?.route?.path}` || '';
                const seoPromise = getLdJson({ ctx, params: { url, pidStrList: pidStrList || '' } });
                const metaInfoPromise = getMetaInfo({
                    ctx,
                    params: {
                        url,
                        pidStrList: pidStrList || '',
                        locale: ctx.req.headers['accept-language'],
                    },
                });
                const [seoRes, metaInfoRes] = await Promise.all([seoPromise, metaInfoPromise]);
                if (seoRes.status === 200) {
                    seoData = seoRes.data;
                }
                if (metaInfoRes.status === 200) {
                    metaInfoData = metaInfoRes.data;
                    title = extractTitleFromMetaInfo({ ctx, metaInfoData });
                }
            } catch (error) {
                console.log(error);
            }
        }

        return {
            seoData,
            metaInfoData,
            title,
            cursor,
            feedsListOrigin,
        };
    },
    head() {
        const head = header(this) as any;

        const firstItem: Feed = this.feedsListOrigin?.[0];
        if (firstItem?.web_feed_type === WebFeedType.PHOTO_CARD) {
            head.link.push({
                rel: 'preload',
                href: firstItem?.cover_first_frame_urls?.[0]?.url,
                as: 'image',
            });

            head.script.push({
                innerHTML: `
                    if (window && !window._preloadVideo) {
                        window._preloadVideo = document.createElement('video');
                        window._preloadVideo.src = '${firstItem?.main_mv_urls?.[0]?.url}';
                        window._preloadVideo.preload = 'auto';
                        window._preloadVideo.load();
                    }
                `,
            });
        }

        return {
            ...head,
        };
    },
    render(c) {
        const comp: any = DiscoverContent;

        return c(comp, {
            props: {
                seoData: this.seoData,
                metaInfoData: this.metaInfoData,
                title: this.title,
                feedsListOrigin: this.feedsListOrigin,
                cursor: this.cursor,
            },
        });
    },
});
